var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-card",style:({ maxWidth: `${_vm.maxWidth}px` })},[_c('div',{staticClass:"info-card__title",style:({
      backgroundColor: _vm.bgColorTitle,
      color: _vm.colorTitle,
      borderTopLeftRadius: `${_vm.borderRadius}px`,
      borderTopRightRadius: `${_vm.borderRadius}px`,
    })},[_c('v-icon',{staticClass:"title__icon",style:({ color: _vm.colorTitle })},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.title)+" ")],1),_c('div',{staticClass:"info-card__content",style:({
      border: `1px solid ${_vm.bgColorTitle}`,
      borderBottomLeftRadius: `${_vm.borderRadius}px`,
      borderBottomRightRadius: `${_vm.borderRadius}px`,
      fontWeight: _vm.fontWeightContent,
      fontSize: `${_vm.fontSizeContent}px`,
    })},[_vm._v(" "+_vm._s(_vm.content)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }